import { useState } from "react";
import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { CATEGORIES } from "@/lib/constants";
import { useWorld } from "@/context/WorldContext";
import { SidebarCategory } from "@/components/SidebarCategory";

export const WorldSidebar = ({ onNavigate }) => {
  const { pages } = useWorld();
  const [q, setQ] = useState("");
  const filtered = pages.filter((p) => p.title.toLowerCase().includes(q.toLowerCase()));

  return (
    <div className="p-4 space-y-5" data-testid="world-sidebar">
      <div className="relative">
        <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-500" />
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search the codex" className="pl-9 bg-canvas" data-testid="sidebar-search-input" />
      </div>
      {CATEGORIES.map((c) => (
        <SidebarCategory key={c.key} c={c} items={filtered.filter((p) => p.category === c.key)} searching={!!q} onNavigate={onNavigate} />
      ))}
    </div>
  );
};
